import React from 'react';
import Spinner from './Spinner';
import './Button.css';

/*
 * Button — the mock's `.btn`.
 *   variant : 'primary' | 'default' | 'ghost' | 'danger'   (default: 'default')
 *   size    : 'md' | 'sm'                                   (default: 'md')
 *   icon    : optional leading element (e.g. <Icon name="plus" />)
 *   loading : shows a spinner and disables the button (aria-busy)
 *   block   : full-width
 * Any extra props (onClick, type, aria-*, …) pass through to <button>.
 */
const VARIANT_CLASS = {
  primary: 'btn--primary',
  default: '',
  ghost: 'btn--ghost',
  danger: 'btn--danger',
};

export default function Button({
  variant = 'default',
  size = 'md',
  icon = null,
  loading = false,
  block = false,
  disabled = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const cls = [
    'btn',
    VARIANT_CLASS[variant] || '',
    size === 'sm' ? 'btn--sm' : '',
    block ? 'btn--block' : '',
    loading ? 'is-loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <Spinner size={size === 'sm' ? 13 : 15} /> : icon}
      {children != null && children !== '' ? <span className="btn__label">{children}</span> : null}
    </button>
  );
}
